const environment = {
    baseUrl: "https://winetours.netea.bg/wp-json/winetours/api/v1/",
    apiKey: 'BJx7GHsjrDleT6NQU2obdc4YRBmRjfZYBjh5h7GvspyakVm'
};
const assetEnvironment = {
    baseUrl: 'https://winetours.netea.bg/wp-content/themes/hello-elementor-child/assets/',
};

if (process.env.REACT_APP_ENV === "development") {
    environment.baseUrl = "https://winetours.loc/wp-json/winetours/api/v1/"
    assetEnvironment.baseUrl = "https://winetours.loc/wp-content/themes/hello-elementor-child/assets/"
}
if (process.env.REACT_APP_ENV === "staging") {
    environment.baseUrl = "https://winetours.netea.bg/wp-json/winetours/api/v1/"
    assetEnvironment.baseUrl = "https://winetours.netea.bg/wp-content/themes/hello-elementor-child/assets/"
}
if (process.env.REACT_APP_ENV === "production") {
    environment.baseUrl = `${window.location.origin}/wp-json/winetours/api/v1/`
    assetEnvironment.baseUrl = `${window.location.origin}/wp-content/themes/hello-elementor-child/assets/`
}

export const envAssets = (asset) => `${assetEnvironment.baseUrl + asset}`;
export default environment;
